// header js
// // メニュートグル
// document.getElementById('menuToggle').addEventListener('click', function() {
//   const fullMenu = document.getElementById('fullMenu');
//   fullMenu.classList.toggle('active');
// });

// // メニュー外クリックで閉じる
// document.addEventListener('click', function(e) {
//   const menu = document.getElementById('fullMenu');
//   const menuBtn = document.getElementById('menuToggle');
  
//   if (!menu.contains(e.target) && !menuBtn.contains(e.target)) {
//     menu.classList.remove('active');
//   }
// });
// // header js終わり
function switchTab(index) {
    const btns = document.querySelectorAll(".tab-btn");
    const contents = document.querySelectorAll(".tab-content");

    btns.forEach((btn, i) => {
      if (i === index) {
        btn.classList.add("active");
      } else {
        btn.classList.remove("active");
      }
    });

    contents.forEach((content, i) => {
      if (i === index) {
        content.classList.add("active");
      } else {
        content.classList.remove("active");
      }
    });
  }
  $(function () {
    $(".js-slick3cols").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false, // ループ不要なら false（必要なら true）
      dots: false, // ★ ドットなし
      arrows: true, // 矢印は表示（不要なら false）
      speed: 400,
      autoplay: false,
      lazyLoad: "ondemand",
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } },
      ],
    });
		// 		//250914変更ここから
		$('.js-sliderLogo').slick({
			infinite: true,
			arrows: false,
			dots: false,
			autoplay: true,
			autoplaySpeed: 0,      // 連続スクロール用（停止なし）
			speed: 12000,          // 遅くしたいほど数値を大きく
			cssEase: 'linear',     // 一定速度で流す
			slidesToShow: 1,       // variableWidthと併用時は1でOK
			slidesToScroll: 1,
			variableWidth: true,   // ロゴ幅がバラバラでも自然に
			pauseOnHover: false,   // ホバーで止めない
			pauseOnFocus: false,
			swipe: false,          // ユーザー操作で速度が乱れないように
			touchMove: false
			// responsiveは不要。どうしても使うなら残してもOK（速度は一定のまま）。
    });
    $('.company-slider').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 5000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    slidesToShow: 4, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 3, // 画面幅750px以下でスライド3枚表示
        }
      }
    ]
  });

    });
    $(".js-sliderShop").slick({
      fade: true,    // fedeオン
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      dots: true, // ★ ドットを有効に変更
      arrows: false,
      speed: 400,
      autoplay: false,
      lazyLoad: "ondemand",
      customPaging: function(slider, i) {
        // 各スライドの画像を取得してサムネイルとして表示
        var thumb = $(slider.$slides[i]).find('img').attr('src');
        return '<img src="' + thumb + '" alt="">';
      },
    });
  (function() {
        // DOMContentLoadedイベント
        document.addEventListener('DOMContentLoaded', function() {
            // mp-top_sliderTitle内の要素のみを取得
            const sliderSection = document.querySelector('.mp-top_sliderTitle');
            if (!sliderSection) return;
            
            const sliderTrack = sliderSection.querySelector('#sliderTrack');
            const list1 = sliderSection.querySelector('#sliderList1');
            const list2 = sliderSection.querySelector('#sliderList2');
            
            if (!sliderTrack || !list1 || !list2) return;
            
            const originalItems1 = Array.from(list1.querySelectorAll('li'));
            const originalItems2 = Array.from(list2.querySelectorAll('li'));
            
            function initializeSlider() {
                // 既存のアイテムをクリア（オリジナル以外）
                const clones1 = list1.querySelectorAll('li.clone');
                const clones2 = list2.querySelectorAll('li.clone');
                clones1.forEach(el => el.remove());
                clones2.forEach(el => el.remove());
                
                // オリジナルアイテムを復元
                if (list1.children.length === 0) {
                    originalItems1.forEach(item => {
                        list1.appendChild(item.cloneNode(true));
                    });
                }
                if (list2.children.length === 0) {
                    originalItems2.forEach(item => {
                        list2.appendChild(item.cloneNode(true));
                    });
                }
                
                // ビューポート幅を取得
                const viewportWidth = window.innerWidth;
                
                // 実際のアイテム幅を計算
                let totalOriginalWidth = 0;
                const items = list1.querySelectorAll('li');
                items.forEach(item => {
                    totalOriginalWidth += item.offsetWidth;
                });
                
                // 最小限の複製数を計算（ビューポート幅をカバーする分だけ）
                const setsNeeded = Math.ceil(viewportWidth / totalOriginalWidth) + 1;
                
                // 必要最小限のクローンを追加
                for (let s = 0; s < setsNeeded; s++) {
                    originalItems1.forEach(item => {
                        const clone = item.cloneNode(true);
                        clone.classList.add('clone');
                        list1.appendChild(clone);
                    });
                    originalItems2.forEach(item => {
                        const clone = item.cloneNode(true);
                        clone.classList.add('clone');
                        list2.appendChild(clone);
                    });
                }
                
                // アニメーション速度を調整
                adjustAnimationSpeed();
            }
            
            function adjustAnimationSpeed() {
                // 1つのリストの総幅を計算（クローンを含まない元のセットのみ）
                let totalWidth = 0;
                const items = list1.querySelectorAll('li:not(.clone)');
                
                // オリジナルセットの幅を計算
                items.forEach(item => {
                    totalWidth += item.offsetWidth;
                });
                
                // 全体の幅（オリジナル + クローン）
                const allItems = list1.querySelectorAll('li');
                let fullWidth = 0;
                allItems.forEach(item => {
                    fullWidth += item.offsetWidth;
                });
                
                // 50%（halfWidth）で1ループするので、その分の時間を計算
                const halfWidth = fullWidth / 2;
                
                // アニメーション時間を計算（ピクセル/秒）
                const pixelsPerSecond = 150; // 速度を上げました
                const duration = halfWidth / pixelsPerSecond;
                
                // スライダートラックのアニメーション時間を設定
                sliderTrack.style.animationDuration = duration + 's';
            }
            
            // 初期化
            initializeSlider();
            
            // リサイズ時に再初期化
            let resizeTimer;
            window.addEventListener('resize', function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    initializeSlider();
                }, 250);
            });
        });
    })();
    // $(".js-sliderLogo").slick({
    //   slidesToShow: 4,
    //   slidesToScroll: 1,
    //   infinite: true, // ループ不要なら false（必要なら true）
    //   dots: false, // ★ ドットなし
    //   arrows: false, // 矢印は表示（不要なら false）
    //   speed: 400,
    //   autoplay: true,
    //   variableWidth: true,
    //   lazyLoad: "ondemand",
    //   responsive: [
    //     { breakpoint: 1024, settings: { slidesToShow: 2 } },
    //     { breakpoint: 896, settings: { slidesToShow: 1 } },
    //   ],
    // });

  (function(){
    function getMainVariantId() {
      const sel = document.getElementById('variant-select-{{ section.id }}');
      if (sel) return sel.value;
      const hidden = document.querySelector('#product-form input[name="id"]');
      return hidden ? hidden.value : null;
    }
    function getQty() {
      const q = document.getElementById('qty-{{ section.id }}');
      return Math.max(1, parseInt(q?.value || '1', 10));
    }
    async function addToCart(items) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({ items })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      window.location.href = '/cart';
    }

    document.querySelectorAll('.c-purchase__acc-item .js-acc-add').forEach(function(el){
      const handler = async function(e){
        e.preventDefault();
        const mainId = getMainVariantId();
        const accVid = el.dataset.accVid;
        if (!mainId) return;

        const items = [{ id: Number(mainId), quantity: getQty() }];
        if (accVid) items.push({ id: Number(accVid), quantity: 1 });

        el.classList.add('is-loading');
        try { await addToCart(items); } catch(e){ console.error(e); }
        finally { el.classList.remove('is-loading'); }
      };
      el.addEventListener('click', handler);
      el.addEventListener('keydown', (e)=>{ if (e.key==='Enter'||e.key===' ') handler(e); });
    });
  })();




(function () {
  function applyPaddingFor(wrap, iframe) {
    if (!wrap || !iframe) return;
    var h = Math.round(iframe.getBoundingClientRect().height || iframe.offsetHeight);
    if (h > 0) wrap.style.paddingTop = h + 'px';
  }

  function setupOne(wrap) {
    var iframe = wrap.querySelector('iframe');
    if (!iframe) return;

    // 最初に一回
    applyPaddingFor(wrap, iframe);

    // iframeの読み込み後にも計測
    iframe.addEventListener('load', function () {
      applyPaddingFor(wrap, iframe);
    });

    // 近代ブラウザ：iframeのサイズ変化を監視
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        applyPaddingFor(wrap, iframe);
      });
      ro.observe(iframe);
    }
  }

  function setupAll() {
    document.querySelectorAll('.c-shop_info_map').forEach(setupOne);
  }

  // フォールバック（古い環境用）：ロード時とリサイズ時に再計測
  function fallbackBind() {
    var throttled;
    window.addEventListener('resize', function () {
      if (throttled) return;
      throttled = setTimeout(function () {
        throttled = null;
        document.querySelectorAll('.c-shop_info_map').forEach(function (wrap) {
          var iframe = wrap.querySelector('iframe');
          applyPaddingFor(wrap, iframe);
        });
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupAll();
      fallbackBind();
      // ページ完全ロード後にも一回（遅延読み込み対策）
      window.addEventListener('load', setupAll);
    });
  } else {
    setupAll();
    fallbackBind();
    window.addEventListener('load', setupAll);
  }
})();

// 価格計算ユーティリティ（税抜cent → 税込cent を -0.999 後に四捨五入）
window.PriceUtil = (function(){
  /** 
   * @param {number} exCents - 税抜(cent) Shopifyのvariant.priceなど（整数）
   * @param {number} taxRatePercent - 税率%（例: 10）
   * @returns {{incCents:number, incYen:number, exCents:number, exYen:number}}
   */
  function inclCentsMinus0999Round(exCents, taxRatePercent){
    const mult = 1 + (Number(taxRatePercent || 0) / 100);   // 1.10 など
    const raw  = exCents * mult;                             // 税込(cent, 小数)
    const incCents = Math.round(raw - 0.999);                // ↓ 0.999引き → round = 実質floor
    const exYen  = Math.floor(exCents / 100);
    const incYen = Math.floor(incCents / 100);
    return { incCents, incYen, exCents, exYen };
  }

  /** 3桁区切りの円表記（整数円） */
  function formatYen(yen){
    return Number(yen).toLocaleString('ja-JP');
  }

  return { inclCentsMinus0999Round, formatYen };
})();

// smoothScroll
(() => {
  let pagelink = document.querySelectorAll('.js-smoothScroll a[href^="#"]');
  const header = document.querySelector('.js-header');
  pagelink.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      let targetId = link.getAttribute("href");
      let target = targetId === "#" || targetId === "" ? document.documentElement : document.querySelector(targetId);
      let position = target.getBoundingClientRect().top + window.pageYOffset;
      if (link.classList.contains('js-editLink') && header) {
        var headerHeight = header.offsetHeight;
        position = position - headerHeight - 30;
      }
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });
})();